import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Heading5 from '../typography/Heading5'
import Paragraph from '../typography/Paragraph'

import './AccordionItem.scss'

const AccordionItem = ({ children, classes, expand, icon, onClick, opened, title, heading4, heading2 }) => (
    <div className={cx('accordion-item', icon && 'hasIcon', opened && 'opened')}>
        <div className='accordion-item-title-block' onClick={onClick}>
            {icon && <div className='icon-container'><img src={icon} alt={title} width={45} height={45} /></div>}
            <div className='border-accordion'>
                {heading4 ?
                    (
                        <h4 className={cx('always-left', opened && classes && classes.titleOpened, classes && classes.title)}>
                            {title}
                        </h4>
                    ) : heading2 ? (
                        <h2 className={cx('always-left', classes && classes.titleOpened, classes && classes.title)}>
                            {title}
                        </h2>
                    ) : (
                        <Heading5 className={cx('always-left', opened && classes && classes.titleOpened, classes && classes.title)}>
                            {title}
                        </Heading5>
                    )
                    
                    }
                    

                <div className={cx('accordion-see-more', expand)}>
                    {!opened && expand === 'text' ?
                        <Paragraph gray>Ver mais</Paragraph>
                        :
                        <div className='arrow-container'></div>
                    }
                </div>
            </div>
        </div>
        <div className={cx('accordion-content', opened ? 'accordion-item-opened' : '')}>
            {children}
        </div>
    </div>
)

AccordionItem.defaultProps = {
    classes: {
        titleOpened: 'heading-purple accordion-title-selected'
    }
}

AccordionItem.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    expand: PropTypes.string,
    icon: PropTypes.string,
    opened: PropTypes.bool,
    title: PropTypes.string,
}

export default AccordionItem



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Accordion/AccordionItem.jsx